import { Tab, TabList, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

// Components
import Mailboxes from "../features/mailboxes/components/Mailboxes";
import Tenant from "../features/tenants/components/Tenant";

// Styles
const useStyles = makeStyles({
  root: {
    background: tokens.colorNeutralBackground1,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  tabContent: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
});

const Settings = ({ themeName, setThemeName }) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState(localStorage.getItem("settingsTab") || "tenant");
  const styles = useStyles();

  const onTabSelect = (event, data) => {
    setSelectedValue(data.value);
    localStorage.setItem("settingsTab", data.value);
  };

  return (
    <div className={styles.root}>
      <TabList
        selectedValue={selectedValue}
        onTabSelect={onTabSelect}
        style={{ marginBottom: "15px", overflowY: "hidden", flexShrink: 0 }}
      >
        <Tab value="tenant">{t("generic.tenant", "Tenant")}</Tab>
        <Tab value="mailboxes">{t("generic.mailboxes", "Mailboxes")}</Tab>
      </TabList>
      <div className={styles.tabContent}>
        {selectedValue === "tenant" && <Tenant />}
        {selectedValue === "mailboxes" && <Mailboxes />}
      </div>
    </div>
  );
};

export default Settings;
